'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Flag = require('./Flag');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Flag).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Flag/index.js
// module id = 1190
// module chunks = 1